import { Box, Typography } from "@mui/material";

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }} component="div">
            {children}
          </Box>
        )}
      </div>
    );
}

export default TabPanel;